import React from 'react';

const LabelControl = ({ field,
   value,
   type,
   className,
   style,
   disabled,
   loading,
   children,
   props
}) => {

   if (value === "" && (field.FieldName === "CreatedDate" || field.FieldName === "CreatedBy" || field.FieldName === "UpdatedDate" || field.FieldName === "UpdatedBy")) {
      return null;
   }
   else if (children) {
      return <div className={className ? className : 'default-label'} style={style ? style : null}>{children}</div>
   }
   else {
      // Use <dt>/<dd> so the label/value pairing is programmatically
      // associated for assistive technology (read-only field display).
      return (<dl className={className ? className : null} key={"field_label_" + field.FieldName} {...props}>
         <dt>{field.DisplayName}</dt>
         <dd>{value}</dd>
      </dl>
      );
   }
}

export default LabelControl;